export const message = {
  officialAnswer: "Official response",
  answerCheckedMessage: "Answer was checked successfully",
  setOfficialAnswerContent:
    "Are you sure you want to make this the official response?",
};
